<template>
  <div class="swiper_con" >
<div :class="navBarFixed == true ? 'navBarWrap' :'navBarWrap444'">
<el-menu
text-color="#FFE3AC"
active-text-color="#FFE3AC"
:default-active="$route.path"
class="el-menu-demo"
mode="horizontal"
@select="handleSelect"
router
>
<div class="left" @click="tohome">
<img src="../assets/img/zhonghao.png" alt=""  class="ZHimg"  width='50px' height='65px' />
<span class="title">Asia Socks&Apparel</span>
</div>

<div class="right">
  <el-menu-item index="/home" class="one">HOME</el-menu-item>
	<!-- <el-submenu index="1">
	   <template slot="title">PRODUCTS</template>
	   <el-menu-item index="/homecate/8" class="two"><div class="item-two"><span>MEN'S</span><i class="iconfont icon-lingxing"></i></div></el-menu-item>
	   <el-menu-item index="/homecate/17" class="two"><div class="item-two"><span>LADIES</span><i class="iconfont icon-lingxing"></i></div></el-menu-item>
	   <el-menu-item index="/homecate/18" class="two"><div class="item-two"><span>KIDS</span><i class="iconfont icon-lingxing"></i></div></el-menu-item>
	    <el-menu-item index="/homecate/33" class="two"><div class="item-two"><span>BABY</span><i class="iconfont icon-lingxing"></i></div></el-menu-item>
	 </el-submenu> -->
 <el-submenu index="2">
    <template slot="title">ABOUT US</template>
    <el-menu-item index="/introduction" class="two"><div class="item-two"><span>Introduction</span><i class="iconfont icon-lingxing"></i></div></el-menu-item>
    <el-menu-item index="/history" class="two"><div class="item-two"><span>History</span><i class="iconfont icon-lingxing"></i></div></el-menu-item>
    <el-menu-item index="/honors" class="two"><div class="item-two"><span>Honors</span><i class="iconfont icon-lingxing"></i></div></el-menu-item>
  </el-submenu>
 <el-submenu index="3">
    <template slot="title">INDUSTRIAL DISTRIBUTION</template>
    <el-menu-item index="/cotton" class="two"><div class="item-two"><span>Cotton socks sector</span><i class="iconfont icon-lingxing"></i></div></el-menu-item>
    <el-menu-item index="/seamless" class="two"><div class="item-two"><span>Seamless sector</span><i class="iconfont icon-lingxing"></i></div></el-menu-item>
    <el-menu-item index="/design" class="two"><div class="item-two"><span>Design center</span><i class="iconfont icon-lingxing"></i></div></el-menu-item>
    <el-menu-item index="/chain" class="two"><div class="item-two"><span>Industry chain integration</span><i class="iconfont icon-lingxing"></i></div></el-menu-item>
  </el-submenu>
   <el-menu-item index="/partners" class="one">PARTNERS</el-menu-item>
   <el-menu-item index="/givingback" class="one">GIVING BACK</el-menu-item>
  <el-menu-item index="/contact" class="one">CONTACT US</el-menu-item>
 <!-- <div class="users" ><i class="iconfont icon-yonghu"></i></div> -->
<!-- <el-submenu index="" v-if="this.menus.length>=1 && this.menus[0].pid !== null">
    <template slot="title">后台管理系统</template>
    <el-menu-item
    v-for="item in menus"
    :index="item.indexPath"
    :key="item.indexPath">{{item.label}}</el-menu-item>
  </el-submenu> -->

  </div>
 <div class="right1" >
	 <el-dropdown  trigger="click" @command="statusChange" >
	   <span class="el-dropdown-link" style="font-size:30px; color: white;">
	    	<i class="el-icon-s-unfold"></i>
	   </span>
	   <el-dropdown-menu slot="dropdown" >
	   <el-dropdown-item


	             v-for="(item,index) in dropList"
	             :key="index"
	             :command="item.value"
				  :disabled="item.disabled"
				    :divided="item.divided"
	          :class="{'selected':status==item.value}"
			  @click.native="routerLinkTo(item.routerLinkTo)"
	           >
			   {{ item.label }}
			   <!-- v-if="item.routerLinkTo!=undefined" 一定要加上，因为先渲染的页面再获取到url的值 -->
			   <!-- <router-link   :to="item.routerLinkTo"  v-if="item.routerLinkTo!=undefined" ></router-link> -->

			   </el-dropdown-item>
	   </el-dropdown-menu>
	 </el-dropdown>



 </div>





</el-menu>



    </div>


  <div :class="topBack == true ? 'topBackShow' :'topBackHidden'" >

	<i class="iconfont icon-Top"
	@click="backtop"
    :style="active"
    @mouseover="mouseOver"
    @mouseleave="mouseLeave"></i>

  </div>



</div>

</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
		timeTop:null,
		 status: 1,
		      dropList: [
		        { value: 1, label: 'HOME',routerLinkTo:'/home',divided:true },
				// { value: 16, label: `PRODUCTS`,disabled:true,divided:true  },
				// { value: 12, label: `MEN'S`,routerLinkTo:'/homecate/8' },
				// { value: 13, label: 'LADIES',routerLinkTo:'/homecate/17' },
				// { value: 14, label: 'KIDS',routerLinkTo:'/homecate/18' },
				// { value: 15, label: 'BABY',routerLinkTo:'/homecate/33' },
				{ value: 17, label: 'ABOUT US',disabled:true,divided:true  },
		        { value: 2, label: 'INTRODUCTION',routerLinkTo:'/introduction' },
		        { value: 3,  label: 'HISTORY',routerLinkTo:'/history' },
		        { value: 4,  label: 'HONORS',routerLinkTo:'/honors' },
				{ value: 18, label: 'INDUSTRIAL DISTRIBUTION',disabled:true,divided:true  },
				{ value: 5,  label: 'COTTON SOCKS SECTOR',routerLinkTo:'/cotton' },
				{ value: 6,  label: 'SEAMLESS SECTOR',routerLinkTo:'/seamless' },
				{ value: 7,  label: 'DESIGN CENTER',routerLinkTo:'/design' },
				{ value: 8,  label: 'INDUSTRY CHAIN INTERGRATION',routerLinkTo:'/chain' },
				{ value: 9,  label: 'PARTNERS',routerLinkTo:'/partners',divided:true },
				{ value: 10,  label: 'GIVING BACK',routerLinkTo:'/givingback',divided:true },
				{ value: 11,  label: 'CONTACT US',routerLinkTo:'/contact',divided:true }
		      ],
      queryInfo:{
      	query:'',
      },
      menus:[],
      navBarFixed:false,
      topBack:false,
      active:'height:50px;width:50px;',
      activeName: 'first',
    };
  },
  computed: {//从vuex的getters里面拿
    ...mapGetters(['username','user_pic','nickname','id'])

  },
  mounted(){
 window.addEventListener('scroll', this.watchScroll,true)

  },

 created() {
   this.getMenusListFn()
  },
  methods: {


    handleSelect(key, keyPath) {
		//解决返回顶部时，切换页面之后，造成的bug
		 clearInterval(this.timeTop)
		 this.timeTop =null
          },

getList() {
      // 控制一下，如果用户没输入东西就不去搜索
      if (this.queryInfo.query === "") {
        return
      } else {
        // 把input带着，发请求获取有关联的数据并呈现在页面中
        this.$router.push({
            path:`/search/${this.queryInfo.query}`,
            //name:this.queryInfo.query
          })
      }
    },
 watchScroll () {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
         //  console.log(scrollTop)
			  const offsetTop = document.querySelector('.swiper_con').offsetTop //观察容器距离顶部的高度
            //  当滚动超过 50 时，实现吸顶效果
            if (scrollTop > offsetTop) {
              this.navBarFixed = true
              this.topBack=true
            } else {
              this.navBarFixed = false
               this.topBack=false
            }
         },
         //返回顶部
         backtop(){

       let top = document.documentElement.scrollTop || document.body.scrollTop
	   //js媒体查询，如果是手机端走以下js
			 let result  = window.matchMedia('(max-width:1200px)')
			 if(result.matches){
					 document.body.scrollTop = document.documentElement.scrollTop = 0
			 }else{
				// 实现滚动效果，平缓滑到头部
				this.timeTop = setInterval(() => {
				  document.body.scrollTop = document.documentElement.scrollTop = top -= 50
				  if (top <= 0) {
				    clearInterval(this.timeTop)
				  }
				}, 10)
			 }




         },
  mouseOver(){
           this.active='color:#409EFF';
         },
  mouseLeave() {
            this.active = 'color: #FFE3AC';
           },
    logout(){
      // 询问用户是否退出登录
        this.$confirm('您确认退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        // // TODO：执行退出登录的操作
        // 1. 清空 token
        //window.sessionStorage.clear()清除所有token
        //window.sessionStorage.removeItem('token', res.token)
        // 2. 跳转到登录页面
        this.$router.push('/login')
        window.sessionStorage.clear()
        location.reload();
        //dispatch：含有异步操作，例如向后台提交数据，写法： this.$store.dispatch('action方法名',值)
            //commit：同步操作，写法：this.$store.commit('mutations方法名',值)
        //退出登录把，vuex状态机数据清空
        this.$store.commit('updateUserInfo',{})
        this.$store.commit('updateMenu',[])
         this.$message({
                   type: 'success',
                   message: '退出登录成功!'
                 });
          }).catch(()=>{
      	 this.$message({
      	           type: 'info',
      	        message: '已取消退出登录'
      	});
      })

    },
    async getMenusListFn () {
       const { data: res } = await this.$http.getMenu()
        this.menus = res.data
        console.log(this.menus)
        //console.log(this.menus.length)

     },

	 statusChange(val){

		  this.status = val
	 },
	 tohome(){
		this.$router.push({
		    path:'/home',
		})
	 },
	 routerLinkTo(name){
		// console.log(111)
		 this.$router.push({
		     path:`${name}`,
		 })
	 }
  },
};
</script>

<style lang="scss" scoped>
	// 使用在线iconfont图标资源
	@import url(//at.alicdn.com/t/c/font_4623761_68z3z45sujk.css);
.title{
	color: white;
	font-size: 24px;
}
.el-menu{
	width: 100%;
  display: flex;
  justify-content: space-around; /* 水平居中 */
  background-color: #000000;
  height: 66px;
  border-bottom: 1px solid  #000000;
  //水平显示溢出
  //overflow-x: hidden;

}

.left{
	display: flex;
	align-items: center;
}
.right{
	display: flex;
	//align-items: center;
	font-family: Serif;
	font-size: 15px;
	font-weight: 600;
}
//最大屏幕宽度，小于1100px
@media screen and (max-width: 1200px) {
  .right {
    display: none;
  }
 .right1 {
   display: flex;
   align-items: center;
  }
  .topBackShow{
   display: block;
   position: fixed;
   right: 15px;
   bottom: 70px;
   z-index: 999;
   cursor: pointer;
  }
  .topBackHidden{
    display: none;
  }


	.el-dropdown-menu {
	    overflow: scroll;
	    max-height: 300px;
	    overflow-x: hidden;
	}
	//不可编辑字体改变颜色
	.el-dropdown-menu__item.is-disabled {
	  color: black

	}

}
//最小屏幕宽度，大于1100px
@media screen and (min-width: 1200px) {
  .right1 {
    display: none;
  }
 .topBackShow{
  display: block;
  position: fixed;
  right: 50px;
  bottom: 70px;
  z-index: 999;
  cursor: pointer;
 }
 .topBackHidden{
   display: none;
 }
}


//一级菜单样式
.el-menu-item {
  color: #FFE3AC;
  //align-content: center;//垂直居中
  margin: 5px;
}

.el-menu-item:hover {
 background-color: #000000 !important;
  color: white !important;
}
.one.el-menu-item.is-active {
	background-color: #000000 !important;
	border: 2px solid #FFE3AC;
    color: #FFE3AC;

}

.item-two{
	display: flex;
	justify-content: space-between;
}
//默认全黑
.iconfont.icon-lingxing{
	color: #000000 ;
	//align-content: center;
}
//选中高亮
.two.el-menu-item.is-active .iconfont.icon-lingxing{
    color: #FFE3AC;
}
 //二级菜单样式
  .el-submenu{
	  display: flex;
	  align-items: center;
	//align-content: center;
  }
  ::v-deep .el-submenu .el-submenu__title{
	  line-height:0px;
	  height: 0px;
  	 color:#FFE3AC;
  }
  .el-submenu.is-active {
  	color: #FFE3AC;
	border: 2px solid #FFE3AC;
    margin: 5px;
  }
//隐藏下拉图标
::v-deep  .el-submenu  .el-submenu__title .el-submenu__icon-arrow{
	display: none;
  }
.users{
	display: flex;
	align-items: center;
	//align-content:center;
	color:#FFE3AC
}
 .iconfont.icon-yonghu{
	 font-size: 20px;
 }
.navBarWrap {
    position:fixed;
    top:0;
    z-index:999;
    width: 100%;
  }
 .navBarWrap444{
width: 100%;

  }


//返回顶部
.iconfont.icon-Top{
	font-size: 50px;
	color: #FFE3AC;
}
.selected{
  color: #40A0FF;
}
a {
  //text-decoration: none;
  color: black;

}
</style>
